import './App.css';
import Map from './Components/Map.jsx';
import Navbar from './Components/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Map/>
    </div>
  );
}

export default App;
